import 'dayjs/locale/nl';
import accounting from 'accounting';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import Vue from 'vue';

import { icon } from '../helpers';

dayjs.locale(window.Laravel.locale);

const {
    decimal,
    precision,
    symbol,
    thousand,
} = window.Laravel.currency;

accounting.settings = {
    currency: {
        decimal,
        precision,
        symbol,
        thousand,
        format: {
            pos: '%s %v',
            neg: '%s -%v',
            zero: '%s %v',
        },
    },
    number: {
        decimal,
        precision,
        thousand,
    },
};

Vue.mixin({
    filters: {
        currency: (cents, inputPrecision = precision) =>
            accounting.formatMoney(cents / 100, {
                symbol: '€',
                precision: inputPrecision,
            }),

        dateAgo: (date) => {
            dayjs.locale(window.Laravel.locale);
            dayjs.extend(relativeTime);

            return dayjs().to(dayjs(date));
        },

        dateFormat: (date, format = 'DD-MM-YYYY') => dayjs(date).format(format),
    },
    data: () => ({
        assetEndpoint: window.Laravel.assetEndpoint || '/',
        blankImage:
            'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
        csrfToken: window.Laravel.csrfToken,
        user: window.Laravel.user,
    }),
    methods: {
        confirmModal(message) {
            return new Promise((resolve) => {
                this.$modal.show('dialog', {
                    title: null,
                    text: message || this.$t('general.confirmation'),
                    buttons: [
                        {
                            title: `<span>${this.$t('general.continue_confirmation')}</span>`,
                            default: true,
                            class: 'btn btn-primary',
                            handler: () => {
                                this.$modal.hide('dialog');
                                resolve();
                            },
                        },
                        {
                            class: 'btn btn-link',
                            title: `<span>${this.$t('general.cancel_confirmation')}</span>`,
                            handler: () => {
                                this.$modal.hide('dialog');
                            },
                        },
                    ],
                });
            });
        },

        getColorByScore(score, reverse = false, range = false) {
            const color = this.getColorArray(range);

            if (reverse) {
                color.reverse();
            }

            if (range) {
                return color[score];
            }

            return color[parseInt(score, 10) - 1];
        },

        getColorArray(range) {
            switch (range) {
                case 2:
                    return [
                        '#B14F57',
                        '#54A254',
                    ];
                case 3:
                    return [
                        '#B14F57',
                        '#F5CB46',
                        '#54A254',
                    ];
                case 4:
                    return [
                        '#B14F57',
                        '#E2A84B',
                        '#C5C04A',
                        '#54A254',
                    ];
                case 5:
                    return [
                        '#B14F57',
                        '#E2A84B',
                        '#F5CB46',
                        '#C5C04A',
                        '#54A254',
                    ];
                case 6:
                    return [
                        '#B14F57',
                        '#CE8450',
                        '#E2A84B',
                        '#C5C04A',
                        '#98B44E',
                        '#54A254',
                    ];
                default:
                    return [
                        '#B14F57',
                        '#CE8450',
                        '#E2A84B',
                        '#F5CB46',
                        '#C5C04A',
                        '#98B44E',
                        '#54A254',
                    ];
            }
        },

        getIcon(name) {
            return icon(name);
        },

        formatNumber(number, fixed = 1) {
            return new Intl.NumberFormat().format(number.toFixed(fixed));
        },

        currentUserLocale() {
            return window.Laravel.locale;
        },
    },
});
